
import { defineComponent, PropType } from "vue";
import Carousel from "primevue/carousel";

export default defineComponent({
  name: "GalleryComponent",
  components: { Carousel },
  props: {
    imageList: {
      type: Array as PropType<Array<Array<string>>>,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
});
